var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid full-width-page-wrapper"},[_c('h3',{staticClass:"font-weight-bold page-title"},[_vm._v("IFAC Technical Areas")]),(_vm.busy)?_c('ifac-loader'):_c('ifac-technical-areas-accordion',{attrs:{"coordinating-committees":_vm.coordinatingCommittees}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }